<template>
    <div>
        <el-dialog
            title="Изменение статуса"
            :visible.sync="$store.getters.showOrderStatusDialog"
            width="60%"
            :before-close="handleClose"
        >
            <el-form id="uploadForm" name="uploadForm" :inline="true" label-position="right" v-loading="isLoad" >
                <el-form-item label="Статус">
                    <el-select v-model="status" placeholder="Выберите статус" @change="validStatus">
                        <el-option
                            v-for="(item, index) in statusConfig"
                            :key="index"
                            :value="item.options"
                            :label="item.title"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="isSendCode" label="Код">
                    <el-input v-model="code">
                    </el-input>
                </el-form-item>
            </el-form>
            <el-button @click="$store.commit('showOrderStatusDialog',false)">Отмена</el-button>
            <el-button @click="saveStatusOrder">Сохранить</el-button>
            <el-button v-if="isSendCode" @click="refreshCode">Отправить код повторно</el-button>
        </el-dialog>
    </div>

</template>

<script>

import axios from "axios";
import statusConfig from '../../../composable/config/order-status.config'


export default {
    props: ['orderId', 'status1', 'paymentType', 'deliveryType', 'needCode'],
    data: () => {
        return{
            status: '',
            statusConfig,
            code: '',
            isLoad: false,
            isSendCode: false,
        }
    },
    mounted() {
      this.$store.subscribe((mutation) => {
          if (mutation.type === 'showOrderStatusDialog' && mutation.payload) {
              this.status = this?.status1 || ''
          }
      })
    },
    methods: {
        saveStatusOrder() {
            let data = {
                status: this.status
            }

            if (this.isSendCode) {
                data.giveaway_code = this.code
            }
            
            this.isLoad = true;

            axios.post('/order/' + this.orderId + '/status', data).then((response) => {
                    if (response.data.success) {
                        this.handleClose()
                        this.$emit('updateParent');
                    } else {
                        this.$notify.error({
                        title: 'Не удалось сменить статус',
                        message: 'На данном этапе выбранный статус установить нельзя'
                        })
                    }

                }
            ).catch((errors) => {
                if (errors.response.status === 401) {
                    this.handleClose()
                    this.$router.push('/login');
                } else if (errors.response.status === 422 && errors.response?.data?.message) {
                    this.$notify.error({
                    title: 'Не удалось сменить статус',
                    message: errors.response.data.message
                    })
                }
            })
            .finally(() => (this.isLoad = false));
        },
        refreshCode() {
            this.isLoad = true;
            axios.post('/order/' + this.orderId + '/send-code').then((response) => {
                    if (response?.data?.success) {
                        this.$notify.success({
                            message: 'Код отправлен'
                        })
                    } else {
                        this.$notify.error({
                            message: 'Не удалось отправить код'
                        })
                    }

                }
            ).catch((errors) => {
                if (errors.response.status === 401) {
                    this.handleClose()
                    this.$router.push('/login');
                } else if (errors.response.status === 422 && errors.response?.data?.message) {
                    this.$notify.error({
                    message: 'Не удалось отправить код'
                    })
                }
            })
            .finally(() => (this.isLoad = false));
        },
        validStatus() {
            if (this.status === 'completed' &&
            (this.paymentType === 'online_card' || this.paymentType === 'bill') &&
            this.deliveryType === 'pickup' && 
            this.needCode) {
                this.isSendCode = true             
            } else {
                this.isSendCode = false
            }
        },
        handleClose() {
            this.$store.commit('showOrderStatusDialog', false);
        },
    }
}
</script>

<style scoped>

</style>